import { Box } from '@mui/material';

import { CostCalculationExternalsSettingsGrid } from 'components/shared/CostCalculationExternalSurcharge/CostCalculationExternalSettingsGrid';
import { CostCalculationExternalSurchargeGrid } from 'components/shared/CostCalculationExternalSurcharge/CostCalculationExternalSurchargeGrid';

export type CostCalculationExternalsSettingsProperties = {
  employmentId?: number;
  organizationalUnitId?: number;
};

export function CostCalculationExternalSettings(
  props: CostCalculationExternalsSettingsProperties
) {
  const { employmentId, organizationalUnitId } = props;

  return (
    <>
      <Box>
        <CostCalculationExternalsSettingsGrid
          employmentId={employmentId}
          organizationalUnitId={organizationalUnitId}
        />
      </Box>
      <Box mt={3}>
        <CostCalculationExternalSurchargeGrid
          employmentId={employmentId}
          organizationalUnitId={organizationalUnitId}
        />
      </Box>
    </>
  );
}
